<!-- @format -->

<template>
    <div class="gst-ticket-price-breakdown">
        {{ priceBreakdown }}
    </div>
</template>

<script>
import currencyFilter from '@core/filters/currencyShort';

export default {
    name: 'EventPriceBreakdown',
    props: {
        basePrice: {
            type: Number,
            required: true,
        },
        feePrice: {
            type: Number,
            required: true,
        },
        hotelPrice: {
            type: Number,
            default: 0,
        },
        currency: {
            type: String,
            required: true,
        },
        allInclusivePricing: {
            type: Boolean,
            default: false,
        },
        processingFee: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        priceBreakdown() {
            return (
                this.basePriceFormatted +
                ' + ' +
                this.feePriceFormatted +
                ' ' +
                this.taxesText +
                (this.processingFee > 0 ? ' + ' + this.orderProcessingFeeFormatted : '')
            );
        },
        basePriceFormatted() {
            return currencyFilter(this.basePrice + this.hotelPrice, this.currency);
        },
        feePriceFormatted() {
            return currencyFilter(this.feePrice, this.currency);
        },
        taxesText() {
            return this.allInclusivePricing
                ? this.$t('_common:terms.includesTaxesAndFeesAbbr')
                : this.$t('_common:terms.ticketTaxesNotIncludedAbbr');
        },
        orderProcessingFeeFormatted() {
            const amount = currencyFilter(this.processingFee, this.currency);
            return this.$t('_common:terms.ticketProcessingFee', { amount: amount });
        },
    },
};
</script>
